import React, {
  useContext,
  useEffect,
  useMemo,
} from "react";

import { useNavigate } from "react-router-dom";
import Slider from "react-slick";

import { ProductsContext } from "../context/ProductsContext";
import { useLanguage } from "../context/LanguageContext";
import { API_BASE_URL } from "../config/api";

import FooterNetwork from "../components/Footer/FooterNetwork";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./home.css";

/* Slider images */
import slide1Apple from "../assets/slide1_apple.jpg";
import slide2Samsung from "../assets/slide2_samsung.jpeg";
import slide3Xiaomi from "../assets/slide3_xiaomi.jpg";
import slide4Technician from "../assets/slide4_technician.jpeg";

/* Fallback image */
import heroImage from "../assets/hero.png";

/* Trust icons */
import yearsIcon from "../assets/years.png";
import guaranteeIcon from "../assets/guarantee.png";
import professionalIcon from "../assets/professional.png";

/* Brand logos */
import appleLogo from "../assets/apple.png";
import samsungLogo from "../assets/samsunglogo.jpg";
import xiaomiLogo from "../assets/xiaomilogo.png";
import huaweiLogo from "../assets/huawei.jpeg";

/* =====================================================
   TRANSLATIONS
===================================================== */

const copy = {
  sq: {
    latestTechnology: "TEKNOLOGJIA MË E FUNDIT",

    appleBadge: "IPHONE",
    appleTitle: "Teknologjia më e fundit në duart tuaja",
    appleDescription:
      "Zbuloni modelet më të fundit Apple, me performancë të fuqishme, dizajn premium dhe teknologji të avancuar.",

    samsungBadge: "SAMSUNG GALAXY",
    samsungTitle: "Fuqi dhe inovacion pa kufij",
    samsungDescription:
      "Eksploroni serinë Samsung Galaxy me kamera profesionale, performancë të lartë dhe eksperiencë inteligjente.",

    xiaomiBadge: "XIAOMI COLLECTION",
    xiaomiTitle: "Performancë që ju surprizon",
    xiaomiDescription:
      "Smartphone Xiaomi me teknologji moderne, kamera të avancuara dhe raport të shkëlqyer cilësi–çmim.",

    repairBadge: "MASTER SOL&TECH",
    repairTitle: "Riparime profesionale të telefonave",
    repairDescription:
      "Zëvendësim ekrani, baterie, riparim bordi, diagnostikim dhe rikuperim të dhënash nga teknikë të specializuar.",

    viewProducts: "Shiko produktet",
    viewServices: "Shiko shërbimet",

    featured: "Produkte në ofertë",
    allProducts: "Shiko të gjitha",
    details: "Shiko detajet",
    loadingProducts: "Produktet po ngarkohen...",

    services: "Shërbimet tona",
    brands: "Markat që ne shesim",
    reviews: "Vlerësime nga klientët tanë",

    repair: "Riparime",
    repairText:
      "Zëvendësim ekrani, baterie dhe riparime profesionale të bordeve.",

    accessories: "Aksesorë",
    accessoriesText:
      "Mbajtëse, karikues, kufje, kabllo dhe shumë produkte të tjera.",

    software: "Shërbimi Softueri",
    softwareText:
      "Zhbllokim pajisjesh, përditësime dhe instalim sistemesh operative.",

    it: "Shërbimi IT",
    itText:
      "Zgjidhje teknologjike profesionale për shtëpi dhe biznese.",

    security: "Garanci & Siguri",
    securityText:
      "Garanci dhe kujdes profesional për çdo produkt dhe shërbim.",

    more: "Më shumë",

    years: "20+ vite përvojë",
    yearsText:
      "Eksperiencë, profesionalizëm dhe besim që nga viti 2004.",

    warranty: "Garanci",
    warrantyText:
      "Garanci për klientin për produktet dhe shërbimet tona.",

    professional: "Servis profesional",
    professionalText:
      "Teknikë të specializuar dhe pajisje moderne diagnostikuese.",

    location: "Në zemër të Tiranës",
    locationText:
      "Vendndodhje lehtësisht e aksesueshme pranë qendrës.",

    review1:
      "Shërbimi më i mirë që kam përjetuar. Ekip profesional dhe zgjidhje shumë e shpejtë.",

    review2:
      "Servis korrekt, staf i sjellshëm dhe mbi të gjitha profesionistë në punën që bëjnë.",

    review3:
      "Ekrani u riparua shumë shpejt dhe telefoni më është kthyer në gjendje perfekte.",

    review4:
      "Master Sol&TECH është zgjedhja ideale për riparime komplekse dhe rikuperim të të dhënave.",
  },

  en: {
    latestTechnology: "THE LATEST TECHNOLOGY",

    appleBadge: "IPHONE",
    appleTitle: "The latest technology in your hands",
    appleDescription:
      "Discover the newest Apple devices with powerful performance, premium design and advanced technology.",

    samsungBadge: "SAMSUNG GALAXY",
    samsungTitle: "Power and innovation without limits",
    samsungDescription:
      "Explore the Samsung Galaxy series with professional cameras, powerful performance and intelligent features.",

    xiaomiBadge: "XIAOMI COLLECTION",
    xiaomiTitle: "Performance that surprises",
    xiaomiDescription:
      "Xiaomi smartphones with modern technology, advanced cameras and excellent value for money.",

    repairBadge: "MASTER SOL&TECH",
    repairTitle: "Professional smartphone repair",
    repairDescription:
      "Screen replacement, battery repair, motherboard repair, diagnostics and data recovery by specialised technicians.",

    viewProducts: "View products",
    viewServices: "View services",

    featured: "Products on offer",
    allProducts: "View all",
    details: "View details",
    loadingProducts: "Loading products...",

    services: "Our services",
    brands: "Brands we sell",
    reviews: "What our customers say",

    repair: "Repairs",
    repairText:
      "Professional screen, battery and motherboard repair services.",

    accessories: "Accessories",
    accessoriesText:
      "Cases, chargers, headphones, cables and many other products.",

    software: "Software Service",
    softwareText:
      "Device unlocking, updates and operating-system installation.",

    it: "IT Service",
    itText:
      "Professional technology solutions for homes and businesses.",

    security: "Warranty & Security",
    securityText:
      "Professional care and warranty for every product and service.",

    more: "Learn more",

    years: "20+ years of experience",
    yearsText:
      "Experience, professionalism and trust since 2004.",

    warranty: "Warranty",
    warrantyText:
      "Customer warranty for our products and services.",

    professional: "Professional service",
    professionalText:
      "Specialised technicians and modern diagnostic equipment.",

    location: "In the heart of Tirana",
    locationText:
      "An easily accessible location close to the city centre.",

    review1:
      "The best service I have experienced. A professional team and a very fast solution.",

    review2:
      "Reliable service, friendly staff and true professionals in everything they do.",

    review3:
      "My screen was repaired very quickly and the phone was returned in perfect condition.",

    review4:
      "Master Sol&TECH is the ideal choice for complex repairs and professional data recovery.",
  },
};

/* =====================================================
   HOME COMPONENT
===================================================== */

export default function Home() {
  const { lang } = useLanguage();

  const {
    products = [],
    fetchProducts,
  } = useContext(ProductsContext);

  const navigate = useNavigate();

  const text = copy[lang] || copy.sq;

  /* ===================================================
     LOAD PRODUCTS
  =================================================== */

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  /* ===================================================
     LATEST PRODUCTS
  =================================================== */

const latestProducts = useMemo(() => {
  return products
    .filter(
      (product) =>
        Number(product.is_published) === 1 &&
        Number(product.is_offer) === 1
    )
    .slice(-8)
    .reverse();
}, [products]);

const getDiscountedPrice = (product) => {
  const price = Number(product.price || 0);
  const discount = Number(product.discount || 0);

  if (discount <= 0) {
    return price;
  }

  return price * (1 - discount / 100);
};

  /* ===================================================
     HERO SLIDES
  =================================================== */

  const heroSlides = useMemo(
    () => [
      {
        id: 1,
        image: slide1Apple,
        badge: text.appleBadge,
        title: text.appleTitle,
        description: text.appleDescription,
        buttonText: text.viewProducts,
        route: "/shop",
        alt: "Apple smartphone collection",
        theme: "dark",
      },

      {
        id: 2,
        image: slide2Samsung,
        badge: text.samsungBadge,
        title: text.samsungTitle,
        description: text.samsungDescription,
        buttonText: text.viewProducts,
        route: "/shop",
        alt: "Samsung Galaxy smartphone",
        theme: "dark",
      },

      {
        id: 3,
        image: slide3Xiaomi,
        badge: text.xiaomiBadge,
        title: text.xiaomiTitle,
        description: text.xiaomiDescription,
        buttonText: text.viewProducts,
        route: "/shop",
        alt: "Xiaomi smartphone collection",
        theme: "light",
      },

      {
        id: 4,
        image: slide4Technician,
        badge: text.repairBadge,
        title: text.repairTitle,
        description: text.repairDescription,
        buttonText: text.viewServices,
        route: "/repair",
        alt: "Master Sol&TECH professional phone technician",
        theme: "dark",
      },
    ],
    [text],
  );

  /* ===================================================
     SERVICES
  =================================================== */

  const services = useMemo(
    () => [
      {
        icon: "fas fa-tools",
        title: text.repair,
        description: text.repairText,
        route: "/repair",
      },

      {
        icon: "fas fa-headphones",
        title: text.accessories,
        description: text.accessoriesText,
        route: "/shop",
      },

      {
        icon: "fas fa-laptop-code",
        title: text.software,
        description: text.softwareText,
        route: "/service",
      },

      {
        icon: "fas fa-network-wired",
        title: text.it,
        description: text.itText,
        route: "/service",
      },

      {
        icon: "fas fa-shield-alt",
        title: text.security,
        description: text.securityText,
        route: "/contact",
      },
    ],
    [text],
  );

  /* ===================================================
     TRUST ITEMS
  =================================================== */

  const trustItems = useMemo(
    () => [
      {
        image: yearsIcon,
        title: text.years,
        description: text.yearsText,
      },

      {
        image: guaranteeIcon,
        title: text.warranty,
        description: text.warrantyText,
      },

      {
        image: professionalIcon,
        title: text.professional,
        description: text.professionalText,
      },

      {
        icon: "fas fa-map-marker-alt",
        title: text.location,
        description: text.locationText,
      },
    ],
    [text],
  );

  /* ===================================================
     SLIDER SETTINGS
  =================================================== */

  const heroSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 800,
    arrows: true,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
  };

const desktopProductSettings = {
  dots: true,
  infinite: latestProducts.length > 6,
  speed: 550,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: true,
  swipeToSlide: true,

  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const mobileProductSettings = {
  dots: true,
  infinite: latestProducts.length > 1,
  speed: 550,
  slidesToShow: 1.35,
  slidesToScroll: 1,
  arrows: false,
  swipeToSlide: true,
  touchMove: true,

  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
      },
    },
    {
      breakpoint: 380,
      settings: {
        slidesToShow: 1.08,
      },
    },
  ],
};

const desktopReviewSettings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5500,
  speed: 550,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  pauseOnHover: true,

  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const mobileReviewSettings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5500,
  speed: 550,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  swipeToSlide: true,
  touchMove: true,
  pauseOnHover: true,
};

  /* ===================================================
     PRODUCT IMAGE
  =================================================== */

  const getProductImage = (product) => {
    if (!product) {
      return heroImage;
    }

    const productImage = Array.isArray(product.images)
      ? product.images[0]
      : product.images;

    if (!productImage) {
      return heroImage;
    }

    const cleanImage = String(productImage).trim();

    if (
      cleanImage.startsWith("http://") ||
      cleanImage.startsWith("https://")
    ) {
      return cleanImage;
    }

    if (cleanImage.startsWith("/uploads/")) {
      return `${API_BASE_URL}${cleanImage}`;
    }

    if (cleanImage.startsWith("uploads/")) {
      return `${API_BASE_URL}/${cleanImage}`;
    }

    return `${API_BASE_URL}/uploads/${cleanImage}`;
  };

  /* ===================================================
     PRODUCT ROUTE
  =================================================== */

  const openProduct = (product) => {
    if (!product?.brand || !product?.model) {
      return;
    }

    navigate(
      `/product/${encodeURIComponent(
        product.brand,
      )}/${encodeURIComponent(product.model)}`,
    );
  };

  /* ===================================================
     REVIEWS
  =================================================== */

  const reviews = [
    {
      text: text.review1,
      customer: "Arben D.",
    },

    {
      text: text.review2,
      customer: "Erion T.",
    },

    {
      text: text.review3,
      customer: "Klajdi M.",
    },

    {
      text: text.review4,
      customer: "Besarta K.",
    },
  ];

  return (
    <main className="home home-light">
      {/* =================================================
          HERO SLIDER
      ================================================= */}

      <section className="hero-section">
        <Slider
          {...heroSettings}
          className="hero-slider modern-hero-slider"
        >
          {heroSlides.map((slide) => (
            <div key={slide.id}>
              <article
                className={`hero-slide hero-slide-${slide.theme}`}
              >
                <div className="hero-copy">
                 <div className="hero-network">
                  <FooterNetwork />
                </div>
                  <span className="hero-tag">
                    {slide.badge}
                  </span>

                  <h1>{slide.title}</h1>

                  <p>{slide.description}</p>

                  <div className="hero-actions">
                    <button
                      type="button"
                      className="hero-btn primary"
                      onClick={() => navigate(slide.route)}
                    >
                      {slide.buttonText}

                      <span aria-hidden="true">→</span>
                    </button>
                  </div>
                </div>

                <div className={`hero-visual hero-image-only hero-visual-${slide.id}`}>
                  <img
                    src={slide.image}
                    alt={slide.alt}
                    loading={
                      slide.id === 1
                        ? "eager"
                        : "lazy"
                    }
                  />
                </div>
              </article>
            </div>
          ))}
        </Slider>
      </section>

      {/* =================================================
          TRUST STRIP
      ================================================= */}

      <section className="trust-strip section-shell">
        {trustItems.map((item) => (
          <article
            className="trust-item"
            key={item.title}
          >
            <div className="trust-icon">
              {item.image ? (
                <img
                  src={item.image}
                  alt=""
                  aria-hidden="true"
                />
              ) : (
                <i
                  className={item.icon}
                  aria-hidden="true"
                />
              )}
            </div>

            <div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </article>
        ))}
      </section>

      {/* =================================================
          LATEST PRODUCTS
      ================================================= */}

  <section className="featured section-shell">
  <div className="section-heading heading-with-link">
    <div>
      <span>MASTER SOL&amp;TECH</span>
      <h2>{text.featured}</h2>
    </div>

    <button
      type="button"
      className="text-link"
      onClick={() => navigate("/shop")}
    >
      {text.allProducts}
      <span aria-hidden="true">→</span>
    </button>
  </div>

  {latestProducts.length > 0 ? (
    <>
      {/* ================= DESKTOP ================= */}
      <div className="hidden md:block">
        <Slider
          {...desktopProductSettings}
          className="products-slider"
        >
          {latestProducts.map((product) => (
            <div
              className="product-slide"
              key={product.id}
            >
              <article
                className="product-card modern-product-card"
                role="button"
                tabIndex={0}
                onClick={() => openProduct(product)}
                onKeyDown={(event) => {
                  if (
                    event.key === "Enter" ||
                    event.key === " "
                  ) {
                    event.preventDefault();
                    openProduct(product);
                  }
                }}
              >
                <div className="product-image-wrap">
                  <img
                    src={getProductImage(product)}
                    alt={product.name || "Product"}
                    loading="lazy"
                  />

                  {Number(product.discount) > 0 && (
                    <span className="new-badge">
                      -{Number(product.discount)}%
                    </span>
                  )}
                </div>

                <div className="product-card-body">
                  <span className="product-brand">
                    {product.brand}
                  </span>

                  <h3>{product.name}</h3>

                  {Number(product.discount) > 0 ? (
                    <div
                      className="product-offer-price"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "nowrap",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "#94a3b8",
                          fontSize: "0.9rem",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                        }}
                      >
                        {Number(product.price || 0).toFixed(2)} ALL
                      </span>

                      <span
                        className="product-price"
                        style={{
                          color: "#dc2626",
                          fontWeight: "800",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                        }}
                      >
                        {getDiscountedPrice(product).toFixed(2)} ALL
                      </span>
                    </div>
                  ) : (
                    <p
                      className="product-price"
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      {Number(product.price || 0).toFixed(2)} ALL
                    </p>
                  )}

                  <button
                    type="button"
                    className="product-details-btn"
                    onClick={(event) => {
                      event.stopPropagation();
                      openProduct(product);
                    }}
                  >
                    {text.details}
                    <span aria-hidden="true">→</span>
                  </button>
                </div>
              </article>
            </div>
          ))}
        </Slider>
      </div>

      {/* ================= MOBILE ================= */}
      <div className="block md:hidden">
        <Slider
          {...mobileProductSettings}
          className="products-slider-mobile"
        >
          {latestProducts.map((product) => (
            <div
              className="product-slide"
              key={product.id}
            >
              <article
                className="product-card modern-product-card"
                role="button"
                tabIndex={0}
                onClick={() => openProduct(product)}
                onKeyDown={(event) => {
                  if (
                    event.key === "Enter" ||
                    event.key === " "
                  ) {
                    event.preventDefault();
                    openProduct(product);
                  }
                }}
              >
                <div className="product-image-wrap">
                  <img
                    src={getProductImage(product)}
                    alt={product.name || "Product"}
                    loading="lazy"
                  />

                  {Number(product.discount) > 0 && (
                    <span className="new-badge">
                      -{Number(product.discount)}%
                    </span>
                  )}
                </div>

                <div className="product-card-body">
                  <span className="product-brand">
                    {product.brand}
                  </span>

                  <h3>{product.name}</h3>

                  {Number(product.discount) > 0 ? (
                    <div
                      className="product-offer-price"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "nowrap",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span
                        style={{
                          textDecoration: "line-through",
                          color: "#94a3b8",
                          fontSize: "0.9rem",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                        }}
                      >
                        {Number(product.price || 0).toFixed(2)} ALL
                      </span>

                      <span
                        className="product-price"
                        style={{
                          color: "#dc2626",
                          fontWeight: "800",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                        }}
                      >
                        {getDiscountedPrice(product).toFixed(2)} ALL
                      </span>
                    </div>
                  ) : (
                    <p
                      className="product-price"
                      style={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      {Number(product.price || 0).toFixed(2)} ALL
                    </p>
                  )}

                  <button
                    type="button"
                    className="product-details-btn"
                    onClick={(event) => {
                      event.stopPropagation();
                      openProduct(product);
                    }}
                  >
                    {text.details}
                    <span aria-hidden="true">→</span>
                  </button>
                </div>
              </article>
            </div>
          ))}
        </Slider>
      </div>
    </>
  ) : (
    <div className="products-loading">
      {text.loadingProducts}
    </div>
  )}
</section>

      {/* =================================================
          SERVICES
      ================================================= */}

      <section className="services section-shell">
        <div className="section-heading centered-heading">
          <span>MASTER SOL&amp;TECH</span>
          <h2>{text.services}</h2>
        </div>

        <div className="services-grid modern-services-grid">
          {services.map((service) => (
            <article
              className="service-card modern-service-card"
              key={service.title}
            >
              <div className="service-icon">
                <i
                  className={service.icon}
                  aria-hidden="true"
                />
              </div>

              <h3>{service.title}</h3>

              <p>{service.description}</p>

           
            </article>
          ))}
        </div>
      </section>

      {/* =================================================
          BRANDS
      ================================================= */}

      <section className="brands section-shell">
        <div className="section-heading centered-heading">
          <span>PARTNERËT TANË</span>
          <h2>{text.brands}</h2>
        </div>

        <div className="brand-logos modern-brand-logos">
          <div className="brand-card">
            <img
              src={appleLogo}
              alt="Apple"
              loading="lazy"
            />
          </div>

          <div className="brand-card">
            <img
              src={samsungLogo}
              alt="Samsung"
              loading="lazy"
            />
          </div>

          <div className="brand-card">
            <img
              src={xiaomiLogo}
              alt="Xiaomi"
              loading="lazy"
            />
          </div>

          <div className="brand-card">
            <img
              src={huaweiLogo}
              alt="Huawei"
              loading="lazy"
            />
          </div>

          <div className="brand-card brand-name-card">
            OPPO
          </div>

          <div className="brand-card brand-name-card">
            realme
          </div>
        </div>
      </section>

      {/* =================================================
          REVIEWS
      ================================================= */}

      <section className="reviews section-shell">
        <div className="section-heading centered-heading">
          <span>5.0 ★★★★★</span>
          <h2>{text.reviews}</h2>
        </div>

       {/* DESKTOP REVIEWS */}
<div className="hidden md:block">
  <Slider
    {...desktopReviewSettings}
    className="reviews-slider"
  >
    {reviews.map((review) => (
      <div
        className="review-slide"
        key={review.customer}
      >
        <article className="review-card modern-review-card">
          <div
            className="review-stars"
            aria-label="5 stars"
          >
            ★★★★★
          </div>

          <p>“{review.text}”</p>

          <strong>— {review.customer}</strong>
        </article>
      </div>
    ))}
  </Slider>
</div>

{/* MOBILE REVIEWS */}
<div className="block md:hidden">
  <Slider
    {...mobileReviewSettings}
    className="reviews-slider-mobile"
  >
    {reviews.map((review) => (
      <div
        className="review-slide"
        key={review.customer}
      >
        <article className="review-card modern-review-card">
          <div
            className="review-stars"
            aria-label="5 stars"
          >
            ★★★★★
          </div>

          <p>“{review.text}”</p>

          <strong>— {review.customer}</strong>
        </article>
      </div>
    ))}
  </Slider>
</div>
        
      </section>
    </main>
  );
}